import { render, staticRenderFns } from "./ExpertAppointmentButton.vue?vue&type=template&id=273fa274"
import script from "./ExpertAppointmentButton.vue?vue&type=script&lang=ts"
export * from "./ExpertAppointmentButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports